import { render } from "./AppHeaderAccnt.vue?vue&type=template&id=b2fa9516&scoped=true"
import script from "./AppHeaderAccnt.vue?vue&type=script&lang=js"
export * from "./AppHeaderAccnt.vue?vue&type=script&lang=js"

import "./AppHeaderAccnt.vue?vue&type=style&index=0&id=b2fa9516&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2fa9516"]])

export default __exports__